import React from 'react';
import { ColumnTree } from '../hooks/useTable/defineColumns';

export const LegendColumn = ColumnTree.defineNode('legend', () => ({
  title: <div className="legenda"></div>,
}));
